import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Save, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

const AddonRow = ({ addon, others, onChange }) => {
  const [a, setA] = useState({ requires: [], ...addon });
  const toggleReq = (id) => setA({ ...a, requires: a.requires.includes(id) ? a.requires.filter((x) => x !== id) : [...a.requires, id] });
  const tid = addon.id || "new";
  const save = async () => {
    const body = { name: a.name, price: Number(a.price) || 0, active: a.active, order: Number(a.order) || 0, requires: a.requires };
    try {
      addon.id ? await api.put(`/admin/addons/${addon.id}`, body) : await api.post("/admin/addons", body);
      toast.success("Zapisano opcję"); onChange();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async () => {
    if (!addon.id) return onChange();
    if (!window.confirm(`Usunąć opcję „${addon.name}”?`)) return;
    await api.delete(`/admin/addons/${addon.id}`); onChange();
  };
  return (
    <div data-testid={`addon-row-${tid}`} className="panel p-4 space-y-3">
    <div className="grid grid-cols-2 sm:grid-cols-[1fr_120px_80px_auto_auto] gap-3 items-center">
      <Input data-testid={`addon-name-${tid}`} value={a.name} onChange={(e) => setA({ ...a, name: e.target.value })} className="bg-black/40 col-span-2 sm:col-span-1" />
      <div className="relative"><Input data-testid={`addon-price-${tid}`} type="number" min="0" value={a.price} onChange={(e) => setA({ ...a, price: e.target.value })} className="bg-black/40 pr-8" /><span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-white/50">zł</span></div>
      <Input type="number" title="Kolejność" value={a.order} onChange={(e) => setA({ ...a, order: e.target.value })} className="bg-black/40" />
      <label className="flex items-center gap-2 text-xs">Aktywna <Switch data-testid={`addon-active-${tid}`} checked={a.active} onCheckedChange={(v) => setA({ ...a, active: v })} /></label>
      <div className="flex gap-2 justify-end">
        <button data-testid={`addon-delete-${tid}`} onClick={remove} className="p-2 rounded-md border border-white/15 text-red-400 hover:border-red-400"><Trash2 size={16} /></button>
        <button data-testid={`addon-save-${tid}`} onClick={save} className="btn-y px-3 py-2"><Save size={16} /></button>
      </div>
    </div>
    {others.length > 0 && (
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="text-white/50 mr-1">Wymaga (nie da się odznaczyć):</span>
        {others.map((o) => {
          const on = a.requires.includes(o.id);
          return <button key={o.id} data-testid={`addon-requires-${tid}-${o.id}`} onClick={() => toggleReq(o.id)}
            className={`px-2.5 py-1 rounded-full border transition-colors ${on ? "bg-primary text-black border-primary font-semibold" : "border-white/15 text-white/60 hover:border-primary/60"}`}>{o.name}</button>;
        })}
      </div>
    )}
    </div>
  );
};

export const AddonsTab = () => {
  const [list, setList] = useState([]);
  const [adding, setAdding] = useState(false);
  const load = () => api.get("/admin/addons").then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="admin-addons-tab" className="max-w-4xl">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-2">
        <h2 className="font-display text-xl sm:text-2xl font-bold">Opcje personalizacji</h2>
        <button data-testid="addon-add-button" disabled={adding} onClick={() => setAdding(true)} className="btn-y px-4 py-2 text-sm inline-flex items-center gap-2"><Plus size={16} /> Dodaj opcję</button>
      </div>
      <p className="text-sm text-muted-foreground mb-6">Opcje dodatkowe, które klient może dobrać w kroku „Spersonalizuj pakiet”. „Wymaga” łączy usługi: gdy klient zaznaczy tę opcję, wymagana zaznaczy się sama i nie da się jej odznaczyć.</p>
      <div className="space-y-3">
        {adding && <AddonRow addon={{ name: "Nowa opcja", price: 0, active: true, order: 99 }} others={list} onChange={() => { setAdding(false); load(); }} />}
        {list.map((a) => <AddonRow key={a.id} addon={a} others={list.filter((o) => o.id !== a.id)} onChange={load} />)}
      </div>
    </div>
  );
};
